import {h} from 'preact'
import iconClose from "../../assets/images/icon-close.svg";
import SearchCategories from "../main-search-results/SearchCategories";
import {useState} from "preact/hooks";

export default ({value, onChange}) => {
    const [opened, setOpened] = useState(false)
    const [search, setSearch] = useState(value)
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            onChange(search)
        }
    }

    return (
        <div className="input-holder">
            <input
                value={search}
                onfocusin={() => setOpened(true)}
                onfocusout={()=> setTimeout(() => setOpened(false), 500)}
                onChange={(e) => {
                    if (!e.target.value) {
                        onChange('')
                    }
                    setSearch(e.target.value)
                }}
                type="text"
                className="input-search"
                placeholder="Search by Salon Name..."
                onKeyDown={handleKeyDown}
            />
            <button className="btn-input-clear">
                <img src={iconClose} onClick={() => setSearch('')} alt="Clear search" />
            </button>
            {opened && !search && <div className="search-dropdown">
                <SearchCategories/>
            </div>}
        </div>
    )
}